<template>
    <div>
<section>
      <h2>Add Credit Card Info</h2>
    </section>
    <form id="pay-bill" @click.prevent="addPayment()">
      <div>
        <button>Add Credit Card Data</button>
      </div>

    </form>
    <div id="paidStatus">

    </div>
    </div>
</template>

<script>
export default {
}
</script>

<style scoped>

</style>